<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">User Details</h4>
    </div>
    <div class="card-content">
      <form>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>First Name</label>
              <input type="text"
                    name="firstName"
                    class="form-control border-input"
                    placeholder="First Name"
                    v-model="authDetails.user.data.firstName"
                    v-validate="modelValidations.firstName">
              <small class="text-danger" v-show="firstName.invalid">
                {{ getError('firstName') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Last Name</label>
              <input type="text"
                    name="lastName"
                    class="form-control border-input"
                    placeholder="Last Name"
                    v-model="authDetails.user.data.lastName"
                    v-validate="modelValidations.lastName">
              <small class="text-danger" v-show="lastName.invalid">
                {{ getError('lastName') }}
              </small>
            </div>
          </div>
        </div>
        
        <div class="text-center">
          <button v-if="!loading" type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="submit">
            Save
          </button>
          <button v-if="loading" type="submit" class="btn btn-info btn-fill btn-wd" disabled="disabled">
            <span class="btn-label">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
            Save
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import {mapFields} from 'vee-validate'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'

  export default {
    props: {
      authDetails: {
        type: Object,
        required: true
      }
    },
    mixins: [toolboxMixin],
    computed: {
      ...mapFields(['firstName',
        'lastName'])
    },
    data () {
      return {
        modelValidations: {
          firstName: {
            required: true
          },
          lastName: {
            required: true
          }
        },
        loading: false
      }
    },
    methods: {
      updateUser () {
        db.collection('users').doc(this.authDetails.user.id).update(this.authDetails.user.data).then(() => {
          this.showNotify('User information saved.', 'success', 'Success')
          this.loading = false
        })
        .catch(error => {
          this.showNotify(error, 'danger', 'Failed')
          this.loading = false
        })
      },
      submit () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.updateUser()
          } else {
            this.loading = false
          }
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/partials/EditProfileForm.vue